import { TaskListItemController } from './task-list-item.controller'

function taskListItem () {
  return {
    restrict: 'E',
    scope: {
      task: '<',
      viewMode: '@',
      options: '<',
      deliveryDate: '<',
      isUser: '<',
      isConsultant: '<'
    },
    templateUrl: '/core/directives/task-list-item/task-list-item-directive.html?$$REVISION$$',
    controller: TaskListItemController
  }
}

export { taskListItem }
